






























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  readonly baseUrl = process.env.BASE_URL || '/';
}
